export default __webpack_public_path__ + "static/media/037-hornbill.4cae46ec.svg";